import React from 'react'
import { Link } from 'react-router-dom'
import { wrapView, format_attr_value, request } from '../smart_bps/lib/utils'
import { stateToProps } from '../smart_bps/bps/base_view'
import { store } from '../index'
import { PROJECT_NAME } from "./constants"
import { SigurListView } from '../lib/SigurListView'
import { Tooltip } from '../smart_bps/lib/components'
import { RequestsModalSearch } from './RequestsModalSearch'
import ApprovalProcessScheme from './ApprovalProcessScheme'
import { SigurModalOrderColumn } from '../common_components/modal_order_column'
import AcceptQueueTopButton from '../lib/AcceptQueueTopButton'

const STATE_FILTERS = [
  { value: '', label: 'Все' },
  { value: 'draft', label: 'Черновик' },
  { value: 'validation', label: 'Проверка' },
  { value: 'review', label: 'Ожидание согласования' },
  { value: 'rework', label: 'Доработка' },
  { value: 'done', label: 'Выполнено' },
]

class ListView extends SigurListView {
  constructor(props) {
    super(props)
    this.searchModalRef = React.createRef()
    this.defaultStateApplied = false
    this.state = {
      ...this.state,
      stateCounters: {},
      showApprovalSchemeModal: false,
      approvalScheme: null,
      approvalSchemeLoading: false,
    }
    this.loadStateCounters = this.loadStateCounters.bind(this)
    this.openApprovalSchemeModal = this.openApprovalSchemeModal.bind(this)
    this.closeApprovalSchemeModal = this.closeApprovalSchemeModal.bind(this)
  }

  componentDidMount() {
    this.applyDefaultStateFilter()
    this.loadStateCounters()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.user !== this.props.user) {
      this.applyDefaultStateFilter()
    }
    if ((prevProps.search_data !== this.props.search_data) || (prevProps.search_preset !== this.props.search_preset)) {
      this.loadStateCounters()
    }
  }

  applyDefaultStateFilter() {
    if (this.defaultStateApplied) return
    const roles = Array.isArray(this.props.user?.roles) ? this.props.user.roles : []
    if (roles.length === 0) return

    let defaultState = ''
    if (roles.length === 1 && roles[0] === 'case_owner') {
      defaultState = 'validation'
    }

    this.defaultStateApplied = true
    this.setStateFilter(defaultState)
  }

  openSearchModal() {
    if (this.searchModalRef.current && typeof this.searchModalRef.current.show === 'function') {
      this.searchModalRef.current.show()
    }
  }

  setStateFilter(value) {
    const base = this.props.search_data || {}
    const newData = value ? { ...base, state: value } : (() => {
      const { state: _s, ...rest } = base
      return rest
    })()
    store.dispatch({ type: `${this.project_name}_search`, data: newData })
  }

  loadStateCounters() {
    const current = this.props.search_data || {}
    const { state: _state, ...baseFilterData } = current

    STATE_FILTERS.forEach(({ value }) => {
      const key = value || '__all__'
      const filter_data = value ? { ...baseFilterData, state: value } : baseFilterData

      request({
        method: 'post',
        url: `/api/${this.project_name}/get_preset_counter`,
        data: {
          filter_data,
          preset: this.props.search_preset,
        },
        success: (count) => {
          this.setState((prev) => ({
            stateCounters: { ...prev.stateCounters, [key]: count || 0 },
          }))
        },
      })
    })
  }

  openApprovalSchemeModal(requestId) {
    if (!requestId) return
    this.setState({
      showApprovalSchemeModal: true,
      approvalScheme: null,
      approvalSchemeLoading: true,
    })
    request({
      method: 'get',
      url: `/api/requests/${requestId}/approval_scheme`,
      success: (data) =>
        this.setState({
          approvalScheme: data || null,
          approvalSchemeLoading: false,
        }),
      error: (err) => {
        console.error('Error loading approval scheme:', err)
        this.setState({
          approvalScheme: null,
          approvalSchemeLoading: false,
        })
      },
    })
  }

  closeApprovalSchemeModal() {
    this.setState({
      showApprovalSchemeModal: false,
      approvalScheme: null,
      approvalSchemeLoading: false,
    })
  }

  renderApprovalSchemeModal() {
    if (!this.state.showApprovalSchemeModal) return null
    return (
      <div
        className="modal fade show approval-scheme-modal"
        style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
        key="approval_scheme_modal"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Схема процесса согласования</h5>
              <button type="button" className="btn-close" onClick={this.closeApprovalSchemeModal} />
            </div>
            <div className="modal-body approval-scheme-modal__body">
              {this.state.approvalSchemeLoading ? (
                <div className="text-muted">Загрузка...</div>
              ) : (
                <ApprovalProcessScheme
                  scheme={this.state.approvalScheme}
                  getChoice={(choiceName, val) => this.getChoice(choiceName, val)}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderModals() {
    let modals = [
      <SigurModalOrderColumn project_name={this.project_name}
      attrs={this.props.attrs}
      table_headers={this.props.table_headers}
      user_table_headers={this.props.user_table_headers} />
    ]

    if (this.props.search_form) {
      modals.push(
        <RequestsModalSearch
          key="search"
          ref={this.searchModalRef}
          project_name={this.project_name}
          schema={this.props.search_form}
          data={this.props.search_data}
          onSearch={this.onSearch}
          choices={this.props.choices}
        />,
      )
    }
    const schemeModal = this.renderApprovalSchemeModal()
    if (schemeModal) modals.push(schemeModal)
    return [...modals, ...(super.renderModals() || [])]
  }

  renderTopPanelLeftItems() {
    let items = super.renderTopPanelLeftItems()
    items = items && items.filter((item) => item?.key !== 'presets')
    const refreshKey = `${this.props.list_page || 1}-${(this.props.list_items || []).length}`
    return [
      ...items,
      <AcceptQueueTopButton
        key="validation_queue"
        projectName={PROJECT_NAME}
        label="Проверить заявку"
        countUrl="/api/requests/validation_queue"
        takeUrl="/api/requests/validation_queue/take_next"
        refreshKey={refreshKey}
      />,
      this.getPresetBtn()
    ]
  }

  renderContent() {
    const searchData = this.props.search_data || {}
    const currentState = searchData.state || ''
    const stateCounters = this.state.stateCounters || {}
    const chips = (
      <div className="card mb-3">
        <div className="card-body py-2">
          <span className="me-2 text-muted small">Этап:</span>
          {STATE_FILTERS.map(({ value, label }) => (
            <button
              key={value || 'all'}
              type="button"
              className={`btn btn-sm me-1 ${currentState === value ? 'btn-primary' : 'btn-outline-secondary'}`}
              onClick={() => this.setStateFilter(value)}
            >
              {label} ({stateCounters[value || '__all__'] ?? 0})
            </button>
          ))}
        </div>
      </div>
    )
    const content = super.renderContent()
    return [chips, ...(Array.isArray(content) ? content : [content])]
  }

  renderTrTd(row, attr_name, idx) {
    const attr = this.props.attrs[attr_name]
    const rawValue = row[attr_name]
    let content
    if (attr_name === 'approval_flow_status' && rawValue != null) {
      const label = attr && attr.choice_name ? this.getChoice(attr.choice_name, rawValue) || rawValue : rawValue
      content = (
        <span
          role="button"
          tabIndex={0}
          style={{ cursor: 'pointer', textDecoration: 'underline' }}
          className="text-primary fw-medium"
          onClick={() => this.openApprovalSchemeModal(row.id)}
          onKeyDown={(e) => e.key === 'Enter' && this.openApprovalSchemeModal(row.id)}
        >
          {label}
        </span>
      )
    } else if (attr_name === 'approvals_count') {
      const num = typeof rawValue === 'number' ? rawValue : (rawValue != null ? Number(rawValue) : 0)
      content = num > 0 ? <Link to={`/${this.project_name}/${row.id}/`}>{num}</Link> : num
    } else if (attr && attr.choice_name) {
      content = this.getChoice(attr.choice_name, rawValue) || rawValue || '---'
    } else {
      content = format_attr_value(attr, rawValue) || '---'
    }

    if (idx === 0 && attr_name !== 'approvals_count') {
      const td_class = row.message ? `text-${row.message.class}` : undefined
      content = (
        <div className="text-nowrap">
          <Link to={`/${this.project_name}/${row.id}/`} className="me-1">
            {content}
          </Link>
          {row.message && <Tooltip message={row.message.text} class_name={td_class} />}
        </div>
      )
    }

    return <td key={attr_name}>{content}</td>
  }
}

export default wrapView(ListView, (state) => {
  return stateToProps(state, PROJECT_NAME)
})
